document.addEventListener('DOMContentLoaded', function () {
    const modal = document.getElementById('AffiliateModal');
    if (!modal) return;

    const headedView = document.getElementById('AffiliateViewHeaded');
    const confirmView = document.getElementById('AffiliateViewConfirm');
    const continueBtn = modal.querySelector('.js-continue-to-partner');
    const copyBtn = modal.querySelector('.js-copy-address');

    // Data State
    let currentProduct = {};

    // 1. Click "Buy" -> Open Headed Modal
    document.addEventListener('click', function (e) {
        const trigger = e.target.closest('.js-affiliate-trigger');
        if (trigger) {
            e.preventDefault();

            const data = trigger.dataset;
            currentProduct = {
                id: data.productId,
                url: data.affiliateUrl,
                partner: data.partnerName,
                title: data.productTitle,
                image: data.productImage,
                price: data.productPrice
            };

            updateModalUI('headed');
            openModal();
        }

        // 2. Click "I purchased this" checkbox/label -> Open Confirm Modal
        const confirmTrigger = e.target.closest('.js-affiliate-confirm-trigger');
        if (confirmTrigger) {
            e.preventDefault();
            const data = confirmTrigger.dataset;
            currentProduct = {
                id: data.productId,
                title: data.productTitle,
                image: data.productImage,
                price: data.productPrice
            };

            updateModalUI('confirm');
            openModal();
        }

        // Close on click outside
        if (e.target === modal || e.target.closest('.js-affiliate-modal-close')) {
            closeModal();
        }
    });

    // 3. Continue to Partner Transitions
    if (continueBtn) {
        continueBtn.addEventListener('click', function () {
            // Swapping view immediately or with slight delay to show it's "ready"
            setTimeout(() => {
                updateModalUI('confirm');
            }, 300);
        });
    }

    // 4. Copy Address Logic
    if (copyBtn) {
        copyBtn.addEventListener('click', function () {
            const addressText = document.querySelector('.js-confirm-address-text').textContent.trim();
            navigator.clipboard.writeText(addressText).then(() => {
                copyBtn.textContent = 'Copied!';
                copyBtn.style.backgroundColor = '#6d326d';
                copyBtn.style.color = '#fff';
                setTimeout(() => {
                    copyBtn.textContent = 'Copy';
                    copyBtn.style.backgroundColor = '#fff';
                    copyBtn.style.color = '#333';
                }, 2000);
            });
        });
    }

    // 5. Success Action -> Open Purchase Drawer
    const yesBtn = modal.querySelector('.js-mark-purchased-yes');
    if (yesBtn) {
        yesBtn.addEventListener('click', function () {
            // 1. Close the current affiliate modal
            closeModal();

            // 2. Open the Purchase Drawer with the current product info
            if (window.PDDrawer) {
                window.PDDrawer.openWithProduct({
                    id: currentProduct.id || '',
                    title: currentProduct.title,
                    img: currentProduct.image,
                    qty: 1
                });
            } else {
                // Fallback: just toggle class if JS object is missing
                const drawer = document.querySelector('.pd-js-overlay');
                if (drawer) drawer.classList.add('is-active');
            }
        });
    }

    // UI Helpers
    function openModal() {
        modal.classList.add('is-active');
        document.body.style.overflow = 'hidden';
        // Reset inline address on open
        const inlineAddress = modal.querySelector('.js-headed-address-box');
        if (inlineAddress) inlineAddress.style.display = 'none';
    }

    function closeModal() {
        modal.classList.remove('is-active');
        document.body.style.overflow = '';
    }

    function updateModalUI(view) {
        if (view === 'headed') {
            headedView.style.display = 'block';
            confirmView.style.display = 'none';

            modal.querySelectorAll('.js-partner-name').forEach(el => el.textContent = currentProduct.partner);

            // CRITICAL: Inject the specific product URL into the continue button
            if (continueBtn) {
                continueBtn.href = currentProduct.url;
            }

            const logoImg = modal.querySelector('.js-partner-logo');
            if (currentProduct.partner.toLowerCase() === 'amazon' || currentProduct.url.includes('amazon')) {
                logoImg.src = 'https://upload.wikimedia.org/wikipedia/commons/a/a9/Amazon_logo.svg';
                modal.querySelectorAll('.js-partner-name').forEach(el => el.textContent = 'Amazon');
            } else {
                logoImg.src = 'https://via.placeholder.com/200x60?text=' + currentProduct.partner;
            }
        } else {
            headedView.style.display = 'none';
            confirmView.style.display = 'block';

            modal.querySelector('.js-confirm-product-title').textContent = currentProduct.title;
            modal.querySelector('.js-confirm-product-image').src = currentProduct.image;
            modal.querySelector('.js-confirm-product-price').textContent = currentProduct.price;
        }
    }

    // Show address link in headed view - TOGGLE logic
    const showAddressLink = modal.querySelector('.js-show-address');
    const headedAddressBox = modal.querySelector('.js-headed-address-box');
    if (showAddressLink) {
        showAddressLink.addEventListener('click', function (e) {
            e.preventDefault();
            if (headedAddressBox.style.display === 'none') {
                headedAddressBox.style.display = 'block';
            } else {
                headedAddressBox.style.display = 'none';
            }
        });
    }
});
